/**
 * @generated SignedSource<<d30e6f4397f11897536b00f57a4173e6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JQLBuilderWithAI$data = {
  readonly shouldShowAtlassianIntelligence: boolean | null | undefined;
  readonly userPreferences: {
    readonly " $fragmentSpreads": FragmentRefs<"NaturalLanguageToJQLWrapper" | "SpotlightTourContainer" | "main_jqlBuilder_JQLBuilder">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderWithAIFilters" | "NaturalLanguageToggle">;
  readonly " $fragmentType": "JQLBuilderWithAI";
};
export type JQLBuilderWithAI$key = {
  readonly " $data"?: JQLBuilderWithAI$data;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderWithAI">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "atlassianIntelligenceProductFeature"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "JQLBuilderWithAI",
  "selections": [
    {
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "feature",
              "variableName": "atlassianIntelligenceProductFeature"
            }
          ],
          "kind": "ObjectValue",
          "name": "atlassianIntelligenceProductFeatureInput"
        },
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "shouldShowAtlassianIntelligence"
    },
    {
      "kind": "FragmentSpread",
      "name": "JQLBuilderWithAIFilters"
    },
    {
      "kind": "FragmentSpread",
      "name": "NaturalLanguageToggle"
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "JiraUserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SpotlightTourContainer"
        },
        {
          "kind": "FragmentSpread",
          "name": "NaturalLanguageToJQLWrapper"
        },
        {
          "kind": "FragmentSpread",
          "name": "main_jqlBuilder_JQLBuilder"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "6fb2c36ec21c1a1c6a6a93f3ca6dcb1d";

export default node;
